import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, EventEmitter, inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AbstractControl, ControlValueAccessor, FormBuilder, FormControl, NG_VALIDATORS, NG_VALUE_ACCESSOR, ReactiveFormsModule, ValidationErrors, Validator, Validators } from '@angular/forms';
import { AnswerOptionItem } from 'src/app/models/answerOptionItem.model';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { EQuestionType, QuestionType } from 'src/app/models/questionType.model';
import { ConnectedPosition, OverlayModule } from '@angular/cdk/overlay';
import { QuestionnaireStore } from 'src/app/store/questionnaire-store';
import { QuestionTypeMenuComponent } from 'src/app/features/create-questionnaire-page/component/question-type-menu/question-type-menu.component';
import { DragStore } from 'src/app/store/drag-store';
import { MatDialog } from '@angular/material/dialog';
import { MessagePopupComponent } from './message-popup/message-popup.component';
import { environment } from 'src/environment';
import { AutoResizeDirective } from 'src/app/directves/autoresize.directive';

@Component({
    selector: 'que-answer-option-item-input',
    imports: [CommonModule, ReactiveFormsModule, TranslateDirective, TranslatePipe, OverlayModule, QuestionTypeMenuComponent, AutoResizeDirective],
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: AnswerOptionItemInputComponent,
            multi: true
        },
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: AnswerOptionItemInputComponent,
            multi: true
        }
    ],
    templateUrl: './answer-option-item-input.component.html',
    styleUrls: ['./answer-option-item-input.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AnswerOptionItemInputComponent implements OnInit, AfterViewInit, ControlValueAccessor, Validator {
  @Input()
  typeId?: number;
  img?: string;//depricated
  @Input()
  isPublic?: boolean | null;
  @Input()
  isUsed?: boolean | null;
  @Input()
  isNew?: boolean | null;
  @Input()
  isSmartQuestion?: boolean | null;
  @Input()
  questionId?: number;
  @Input()
  fromPopup=false;
  @Input()
  isInFollowQuestion=false;
  @Output()
  deleteEvent = new EventEmitter();
  @Output()
  addEvent = new EventEmitter();

  #dragStore = inject(DragStore);
  #dialog = inject(MatDialog);
  answerOptionItemString = new FormControl<String>('', [Validators.required]);
  @ViewChild('inputElement') inputElement!: ElementRef<HTMLInputElement>;
  @ViewChild('trigger') trigger!: ElementRef;
  answerOptionItem?: AnswerOptionItem;
  registerOnChangeCallback: any = () => { };
  onValidationChangeCallBack: any;

  isSelectOpen = false;
  isCanBeRemoved = false;

  readonly positonArea = [{
    originX: 'center',
    originY: 'center',
    overlayX: 'center',
    overlayY: 'center',
  }] as ConnectedPosition[];

  ngOnInit(): void {
    this.img = this.typeId == EQuestionType.Mark ? "mark" : this.typeId == EQuestionType.Multi ? "multi" : "option";
    this.answerOptionItemString.valueChanges.subscribe(name => {
      this.registerOnChangeCallback({ ...this.answerOptionItem, name: name });
    });
  }
  ngAfterViewInit(): void {
    if (this.isNew) {
      this.focusInput()
    }
  }
  validate(control: AbstractControl<any, any>): ValidationErrors | null {
    if (this.answerOptionItemString.valid) {
      return null;
    }
    return { 'answerOptionItemString': "not-valid" }
  }
  writeValue(obj: any): void {
    this.answerOptionItem = obj;
    this.isCanBeRemoved = obj.isNew;
    this.answerOptionItemString.setValue(obj.name, { emitEvent: false });
    //this.onValidationChangeCallBack();xxx
  }
  registerOnValidatorChange?(fn: () => void): void {
    this.onValidationChangeCallBack = fn;
  }

  registerOnChange(fn: any): void {
    this.registerOnChangeCallback = fn;
  }
  registerOnTouched(fn: any): void {
  }
  delete() {
    if (!this.isPublic && (!this.isUsed || this.isCanBeRemoved) && !this.isSmartQuestion) {
      if (this.answerOptionItem?.followQuestionChildsIdes?.length ?? 0 > 0) {
        this.#dialog.open(MessagePopupComponent, { data: environment.lang=='he'?{ message: "האם אתה בטוח שברצונך למחוק פריט זה?" ,message2:".שים לב: שאלות ההמשך שמקושרות לפריט זה ימחקו גם הן"}:{message:"Are you sure you want to delete this item?",message2:"Note that follow-up questions linked to this item will also be deleted"} }).afterClosed().subscribe(
          x => {
            if (x) {
              //delete all
              this.#dragStore.deleteFollowQuestionsByIds({ optionGuid: this.answerOptionItem?.guid ?? "none", questionIdes: this.answerOptionItem?.followQuestionChildsIdes ?? [] })
              this.deleteEvent.emit()
            }
          }
        );
      }
      else {
        this.deleteEvent.emit()
      }
    }
  }
  onEnter() {
    this.addEvent.emit();
    // Add your logic here to be executed when Enter key is pressed
  }
  focusInput() {
    if (this.inputElement) {
      this.inputElement.nativeElement.focus();
    }
  }
  addFollowQuestion(type: QuestionType) {
    if (this.questionId && this.answerOptionItem?.guid) {
      this.#dragStore.addFollowUpQuestion({ questionId: this.questionId, optionItemGuid: this.answerOptionItem?.guid, type })
      this.isSelectOpen = false;
    }
  }
  openSelectType() {
    const triggerRect = this.trigger.nativeElement.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    // Check if the menu would open out of the viewport
    if (triggerRect.bottom + 150 > viewportHeight) { // assuming 200px height for the menu
      this.positonArea[0].overlayY = 'bottom';
    } else {
      this.positonArea[0].overlayY = 'center';
    }
    this.isSelectOpen = true;
  }
}
